export async function trackEvent (store, params) { // eslint-disable-line no-unused-vars
}
